import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { ExtensionContainer } from '@/containers/enrich/extension/extension-container.component';
import { extensionRouteRedirects } from '@/containers/integrations/extension-tab.util';
import { useExtensionNavigation } from '@/hooks/use-extension-navigation.hook';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/extension')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const extension = useExtensionNavigation();
  // The extension is a tab of Integrations, so the installer is too.
  const redirect = extensionRouteRedirects(extension);

  useEffect(() => {
    if (redirect) {
      void navigate({
        to: '/integrations',
        search: { tab: 'extension' },
        replace: true,
      });
    }
  }, [redirect, navigate]);

  if (redirect) {
    return null;
  }

  return (
    <>
      <Head heading='Browser Extension' />
      <AuthCheck>
        <AppLayout variant='full-bleed'>
          <ExtensionContainer
            installationAware
            installationState={{
              isReady: extension.detectionReady,
              isInstalled: extension.installedInBrowser,
            }}
          />
        </AppLayout>
      </AuthCheck>
    </>
  );
}
